import Axios from "axios";
import { ApiResultModel } from "../models/common.model";
import {
  GetSupplierSalesLocationRequest,
  GetSupplierSalesLocationResponse,
  GetSupplierSalesLocationResponseDATA,
} from "../models/map.model";
import { ApiBaseUrl, MapURL } from "../config/config";

export const GetSupplierSalesLocation = (
  data: GetSupplierSalesLocationRequest
): Promise<ApiResultModel<GetSupplierSalesLocationResponseDATA>> => {
  return Axios.post<ApiResultModel<GetSupplierSalesLocationResponseDATA>>(
    ApiBaseUrl + MapURL + "/GetSupplierSalesLocation",
    data
  ).then((result) => {
    return result.data;
  });
};
